module.exports = __webpack_public_path__ + "static/MC_steps_nuevos_FISICA_5_B-43b5c85f13d176b6f4c77d0d0f96ae93.gif";